import { Navigate, useLocation, useParams } from '@suntex.core/nav';

import { PREVIEW_ROUTE } from '../../const';

/** Redirects legacy `/preview/player/*` links (mounted at `player/*` under `/preview`) to the `/preview` dashboard hash. */
export function PreviewPathRedirect() {
  const rest = useParams()['*'] ?? '';
  const { search } = useLocation();
  return <Navigate to={`${PREVIEW_ROUTE}${search}#/${rest}`} replace />;
}
